/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import CommunicatorSchedule from '../communicator/schedule/communicator-schedule';
import CommunicatorUtility from '../communicator/utility/communicator-utility';
import TrackCommunicator from '../track/track-communicator';

/**
 * Komunikátor playlistů pro Ki-Wi Server.
 */
export default class PlaylistCommunicator {
  /**
   * Načte seznam playlistů a zanořené stopy.
   * @param {Object[]} jsonArray Část odpovědi na obsah zařízení se seznamem playlistů.
   * @returns {import('./playlist').Playlist[]} Pole atributů pro Playlist a Track v Playlist.tracks.
   */
  static parseMany(jsonArray) {
    return jsonArray.map(this.parseOne);
  }

  /**
   * Načte jeden playlist a zanořené stopy.
   * @param {Object} json Část odpovědi na obsah zařízení s jedním playlistem.
   * @returns {import('./playlist').Playlist} Atributy pro Playlist a Track v Playlist.tracks.
   */
  static parseOne(json) {
    try {
      // TODO: Validace typů položek.
      const { id } = json;
      const { cut, deterministic, scope } = json.scheduler;
      return {
        cut,
        deterministic,
        id,
        name: json.name,
        scheduleEnum: CommunicatorSchedule.parse(json.scheduler.type),
        scope,
        tracks: TrackCommunicator.parseMany(json.tracks, id),
        volume: CommunicatorUtility.parsePercentage(json.volume)
      };
    } catch (error) {
      throw new TypeError(`parsing playlist ${JSON.stringify(json)}: ${error}`);
    }
  }
}
